import classNames from 'classnames';
import styles from './CarouselButton.module.scss';
import { ReactComponent as Arrow } from '../../../assets/schedule-arrow.svg';

interface CarouselButtonProps {
  variant?: 'left' | 'right';
  className?: string;
  onClick: () => void;
}

export default function CarouselButton({
  variant = 'right',
  className,
  onClick,
}: CarouselButtonProps): JSX.Element {
  return (
    <button
      className={classNames(styles.root, className && className)}
      onClick={onClick}
    >
      <Arrow
        className={classNames(styles.icon, variant === 'left' && styles.left)}
      />
    </button>
  );
}
